import { ReactNode } from 'react';
import { DeviceType } from 'shared/models/device-type';

import LinkableTransmitterStepsProviderContext from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/contexts/linkable-transmitter-steps-provider-context';
import useLinkableTransmitterStepsProviderState from 'features/residents/resident-settings/components/resident-setting-details/components/devices-accordion/components/details-devices/components/linkable-transmitter-steps/providers/states/linkable-transmitter-steps-provider-state';

type Props = {
  children: ReactNode;
  toggleLinkableTransmitterSteps: () => void;
  onTransmitterAdded: (createdDeviceId: string) => void;
  transmitterResidentSettings: DeviceType[];
};

const LinkableTransmitterStepsProvider = ({
  children,
  toggleLinkableTransmitterSteps,
  onTransmitterAdded,
  transmitterResidentSettings,
}: Props): React.JSX.Element => (
  <LinkableTransmitterStepsProviderContext.Provider
    value={useLinkableTransmitterStepsProviderState({ toggleLinkableTransmitterSteps, onTransmitterAdded, transmitterResidentSettings })}
  >
    {children}
  </LinkableTransmitterStepsProviderContext.Provider>
);

export default LinkableTransmitterStepsProvider;
